import { useState } from 'react';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { GOLD, fmt, num, Stat, Field, Card, EntryTable, useEntries } from './shared';

export const LaborTab = ({ api, jobId, readOnly }) => {
  const [data, reload] = useEntries(api, `/accounting/jobs/${jobId}/labor`, jobId);
  const [form, setForm] = useState({ employee_name: '', date: '', hours: 0, hourly_rate: '', description: '' });
  const add = async () => {
    if (!form.employee_name || !form.date) return toast.error('Name and date required');
    try {
      await api.post(`/accounting/jobs/${jobId}/labor`, { job_id: jobId, ...form, hourly_rate: form.hourly_rate || null });
      setForm({ employee_name: '', date: '', hours: 0, hourly_rate: '', description: '' });
      reload(); toast.success('Labor entry added');
    } catch { toast.error('Failed'); }
  };
  if (!jobId) return <p className="text-gray-500">Select a project.</p>;
  return (
    <div data-testid="fos-labor-tab">
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <Stat label="Total Hours" value={num(data.summary?.total_hours)} testid="labor-total-hours" />
        <Stat label="Total Labor Cost" value={fmt(data.summary?.total_cost)} accent={GOLD} testid="labor-total-cost" />
        <Stat label="Entries" value={data.entries?.length || 0} />
      </div>
      {!readOnly && (
        <Card className="mb-6">
          <div className="grid sm:grid-cols-5 gap-3 items-end">
            <Field label="Employee" type="text" value={form.employee_name} onChange={(v) => setForm({ ...form, employee_name: v })} testid="labor-name" />
            <Field label="Date" type="date" value={form.date} onChange={(v) => setForm({ ...form, date: v })} testid="labor-date" />
            <Field label="Hours" value={form.hours} onChange={(v) => setForm({ ...form, hours: v })} testid="labor-hours" />
            <Field label="Rate (blank=burden)" value={form.hourly_rate} onChange={(v) => setForm({ ...form, hourly_rate: v })} testid="labor-rate" />
            <button data-testid="labor-add-btn" onClick={add} className="h-10 inline-flex items-center justify-center gap-2 px-4 bg-[#C6A87C] text-white text-sm font-medium rounded-lg hover:opacity-90">
              <Plus className="w-4 h-4" /> Add
            </button>
          </div>
        </Card>
      )}
      <EntryTable
        headers={['Date', 'Employee', 'Hours', 'Rate', 'Total']}
        rows={(data.entries || []).map(e => [e.date, e.employee_name, e.hours, fmt(e.hourly_rate), fmt(e.total_cost)])}
        testid="labor-table"
      />
    </div>
  );
};
